<p>layout-three-column works!</p>

<div *ngFor="let item of dataModules">
    {{item}}
</div>
